import { useEffect, useRef } from 'react';
import { WorkerSettings } from '@/components/features/profile/WorkerSettings';

export function AvailabilityPopover({
  open,
  onClose,
  placement = 'sidebar',
}: {
  open: boolean;
  onClose: () => void;
  placement?: 'sidebar' | 'profile';
}) {
  const panel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const key = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    const outside = (event: MouseEvent) => {
      if (panel.current && !panel.current.contains(event.target as Node))
        onClose();
    };
    document.addEventListener('keydown', key);
    const timer = setTimeout(
      () => document.addEventListener('mousedown', outside),
      0
    );
    return () => {
      clearTimeout(timer);
      document.removeEventListener('keydown', key);
      document.removeEventListener('mousedown', outside);
    };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div
      ref={panel}
      role="dialog"
      aria-label="Availability for Hire"
      className={
        'fixed left-4 right-4 z-50 rounded-xl border border-[--base-border] bg-[--base-surface-1] p-6 shadow-xl lg:w-[420px] ' +
        (placement === 'profile'
          ? 'top-[140px] lg:left-auto lg:right-4'
          : 'bottom-4 lg:absolute lg:left-full lg:right-auto lg:ml-2')
      }
    >
      <button
        type="button"
        className="float-right"
        onClick={onClose}
        aria-label="Close availability"
      >
        ×
      </button>
      <WorkerSettings kind="calendar" />
    </div>
  );
}
